import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { WalletType } from '~/shared';
import { CaseItem, CaseType as CaseTypes, calcOldPrice } from '../CaseItem';
import { StyledContainer, StyledEmptyContainer } from './ShopKits.styled';

const ShopKits = () => {
	const bundles = useObservable(rage.cases.getBundles());

	if (bundles.length === 0) {
		return (
			<StyledEmptyContainer>
				<Text>
					К сожалению,
					<br />
					доступных наборов нет
				</Text>
			</StyledEmptyContainer>
		);
	}

	return (
		<StyledContainer>
			{bundles.map((item, index) => (
				<CaseItem
					id={item.id}
					name={item.name}
					type={CaseTypes.Kit}
					image={item.id}
					discount={item.discount ?? 0}
					price={item.price ?? 0}
					wallet={item.walletType as WalletType.Cash | WalletType.Donate}
					oldPrice={calcOldPrice(item.price ?? 0, item.discount ?? 0)}
					key={index}
					tags={item.tags}
					dateDiscountEnd={item.discountTimestampEnd}
					dateEnd={item.enabledTimestampEnd}
				/>
			))}
		</StyledContainer>
	);
};

export { ShopKits };
